import { combineReducers } from "redux";
import summary from "./summary/dataSlice";

const reducer = combineReducers({
  summary,
});

export default reducer;
